import { useConfiguration } from '@travel-frontend/core';
import axios from 'axios';
import { useCallback, useMemo, useState } from 'react';
export const useUpliftAds = () => {
  const {
    apiUrl,
    apiKey,
    siteId
  } = useConfiguration('upliftAds') || {};
  const {
    tld
  } = useConfiguration(['tld']);
  const defaultKeywords = useMemo(() => [`Market.${tld ? tld.toUpperCase() : 'DE'}`], [tld]);
  const [advertisements, setAdvertisements] = useState(new Map([]));
  const [isLoading, setIsLoading] = useState(false);
  const getAdvertisements = useCallback(async ({
    zoneIds,
    keywords,
    customTargeting,
    count = 1
  }) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${apiUrl}`, {
        siteId,
        zoneIds,
        // eventIds: [
        //   {
        //     id: 1,
        //     label: 'ViewconversionUrl',
        //   },
        //   {
        //     id: 2,
        //     label: 'ClickconversionUrl',
        //   },
        //   {
        //     id: 3,
        //     label: 'conversionUrl',
        //   },
        // ],
        count,
        keywords: [...keywords, ...defaultKeywords],
        customTargeting
      }, {
        headers: {
          'x-api-key': apiKey,
          'x-site-id': siteId
        }
      });
      const decisions = Object.values(response.data.decisions);
      const mapAdsToZoneIds = new Map();
      for (const [index, zoneId] of zoneIds.entries()) {
        const decision = decisions[index];
        if (Array.isArray(decision) && decision.length > 0) {
          mapAdsToZoneIds.set(zoneId, decision);
        }
      }
      setAdvertisements(mapAdsToZoneIds);
    } catch {
      setAdvertisements(new Map([]));
    }
    setIsLoading(false);
  }, [apiKey, apiUrl, defaultKeywords, siteId]);
  return {
    getAdvertisements,
    advertisements,
    isLoading
  };
};